/* pdp-flickity-lifecycle.js
   Permanent fix for Flickity on Shopify PDP (desktop-only by default). */

(function () {
  // ---- config (change if needed)
  const DESKTOP_ONLY = true; // set false if you want on mobile too
  const SELECTORS = [
    '.pdp-product-slideshow.Carousel', // main gallery
    '.carousel.carousel-nav'           // thumb nav
  ];

  // ---- tiny helpers
  const $$ = (s, root = document) => Array.from(root.querySelectorAll(s));
  const exists = (root) => SELECTORS.some(sel => root.querySelector(sel));

  // Track instances safely
  const sliderMap = new WeakMap();

  // Init when visible (avoids width=0 if in hidden tabs/accordions)
  function whenVisible(el, cb) {
    const visible = () => el.getClientRects().length > 0 && el.offsetParent !== null;
    if (visible()) return cb();
    const ro = new ResizeObserver(() => {
      if (visible()) { ro.disconnect(); cb(); }
    });
    ro.observe(document.body);
  }

  function canRun() {
    if (!DESKTOP_ONLY) return true;
    return window.matchMedia('(min-width: 769px)').matches;
  }

  function initOne(el) {
    if (!el || sliderMap.has(el)) return;

    // read inline config if present
    let opts = {};
    const cfg = el.getAttribute('data-flickity-config');
    if (cfg) { try { opts = JSON.parse(cfg); } catch (_) {} }

    // sensible defaults (merge but don't fight your own config)
    opts = Object.assign({
      imagesLoaded: true,
      percentPosition: true,
      draggable: '>1'
    }, opts);

    whenVisible(el, () => {
      // Guard against null or missing Flickity
      if (typeof Flickity !== 'function') return;
      const inst = new Flickity(el, opts);
      sliderMap.set(el, inst);
    });
  }

  function mount(root = document) {
    if (!canRun()) return;
    SELECTORS.forEach(sel => $$(sel, root).forEach(initOne));
  }

  function unmount(root = document) {
    SELECTORS.forEach(sel => {
      $$(sel, root).forEach(el => {
        const inst = sliderMap.get(el);
        if (inst) {
          try { inst.destroy(); } catch (_) {}
          sliderMap.delete(el);
        }
      });
    });
  }

  // Resize/rehydrate existing instances (don’t re-init blindly)
  const debounced = (fn, ms = 150) => {
    let t; return () => { clearTimeout(t); t = setTimeout(fn, ms); };
  };
  const resizeAll = debounced(() => {
    // If breakpoint crossed from mobile→desktop, ensure mount
    if (canRun()) mount();
    // Resize any live instances
    SELECTORS.forEach(sel => {
      $$(sel).forEach(el => {
        const inst = sliderMap.get(el);
        if (inst && inst.resize) inst.resize();
      });
    });
  }, 150);

  // ---- Global lifecycle wiring
  document.addEventListener('DOMContentLoaded', () => { if (exists(document)) mount(); });
  window.addEventListener('resize', resizeAll, { passive: true });
  window.addEventListener('orientationchange', resizeAll, { passive: true });

  // Back/forward cache resume
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) { mount(); resizeAll(); }
  });

  // Shopify section lifecycle
  document.addEventListener('shopify:section:load', (e) => mount(e.target));
  document.addEventListener('shopify:section:unload', (e) => unmount(e.target));

  // Turbo / PJAX (if used by theme/apps)
  document.addEventListener('turbo:before-render', () => unmount(document));
  document.addEventListener('turbo:load', () => { if (exists(document)) mount(); });

  // As a safety, destroy on pagehide (nav away)
  window.addEventListener('pagehide', () => unmount(document));
})();
